import React from 'react'
import PropTypes from 'prop-types'
import { RichTextEditor, FroalaTextEditor } from 'components/UIElements'
import AuthenticatedImage from 'components/AuthenticatedImage'
import { capitalize } from 'utils/misc'
import { INSTRUMENT_TYPE_MAP } from 'utils/constants'
import SurveyQuestionView from '../../EditSurvey/components/QuestionView'
import ClinroQuestionView from '../../EditClinro/components/QuestionView'
import DiaryQuestionView from '../../EditDiary/components/DiaryQuestionView'
import STRINGS from 'utils/strings'
import useInstrumentUnificationFeature from 'utils/hooks/useInstrumentUnificationFeature'

const ItemListView = props => {
  const {
    consent,
    order,
    questions,
    instrumentType,
    isSurvey = true,
    isClinro,
    isDiary,
    caregiverEnabled,
    study,
    userId,
  } = props

  const { hasInstrumentUnification } = useInstrumentUnificationFeature({ study, userId })

  const getTitle = () => {
    if (!hasInstrumentUnification) {
      return instrumentType !== INSTRUMENT_TYPE_MAP.clinro
        ? capitalize(instrumentType.toLowerCase())
        : 'Clinician Instrument'
    }

    if (instrumentType === INSTRUMENT_TYPE_MAP.clinro) {
      return STRINGS.clinicianInstrument
    }
    if (instrumentType === INSTRUMENT_TYPE_MAP.survey) {
      return STRINGS.participantInstrument
    }
    return capitalize(instrumentType.toLowerCase())
  }

  return (
    <div className='page-break'>
      {!consent && <h4>{`${getTitle()} Questions`}</h4>}
      {order.map(itemId => {
        const item = questions[itemId]
        const { imageSrc, mediaSrc, resources } = item
        const hasVideo = !!resources?.video
        const questionViewProps = {
          itemId,
          item,
        }
        return (
          <div className='survey-question avoid-break' key={itemId}>
            <div className='survey-question-inner'>
              {item.attributes.questionNumber && (
                <span className='question-number'>{`${item.attributes.questionNumber}.`}</span>
              )}
              <FroalaTextEditor value={item.label} readOnly={true} showToolbar={false} />
            </div>
            {isSurvey && <SurveyQuestionView preview caregiverEnabled={caregiverEnabled} {...questionViewProps} />}
            {isClinro && <ClinroQuestionView preview {...questionViewProps} />}
            {isDiary && <DiaryQuestionView preview {...questionViewProps} />}
          </div>
        )
      })}
    </div>
  )
}

ItemListView.propTypes = {
  consent: PropTypes.object,
  instrumentType: PropTypes.string,
  isSurvey: PropTypes.bool,
  order: PropTypes.array,
  questions: PropTypes.object,
  caregiverEnabled: PropTypes.bool,
}

export default ItemListView
